// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Notification = function Notification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0c-.692 0-1.25.559-1.25 1.25V2a6.25 6.25 0 0 0-5 6.125v.992a7.82 7.82 0 0 1-1.712 4.88l-.582.73a.935.935 0 0 0 .73 1.523h15.626a.938.938 0 0 0 .73-1.523L17.96 14a7.84 7.84 0 0 1-1.71-4.883v-.992a6.25 6.25 0 0 0-5-6.125v-.75C11.25.559 10.69 0 10 0m0 3.75a4.373 4.373 0 0 1 4.374 4.375v.992c0 1.871.543 3.695 1.55 5.258H4.075a9.7 9.7 0 0 0 1.55-5.258v-.992A4.373 4.373 0 0 1 10 3.75m2.5 13.75h-5c0 .664.26 1.3.73 1.77A2.5 2.5 0 0 0 10 20a2.5 2.5 0 0 0 1.769-.73 2.5 2.5 0 0 0 .73-1.77"
  }));
};
